/* ==========================================================================
   VELU — comportamento do tema
   Substitui Zustand + Motion + Radix do storefront React por JS nativo.
   ========================================================================== */
(function () {
  'use strict';

  var CFG = (window.VELU && window.VELU.settings) || {};
  var ROUTES = (window.VELU && window.VELU.routes) || {};

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ------------------------------------------------------------ age gate --- */
  function initAgeGate() {
    var gate = $('[data-age-gate]');
    if (!gate) return;

    var key = CFG.ageGateKey || 'velu-age-verified';
    if (localStorage.getItem(key) === 'true') return;

    var gatePanel = $('[data-age-gate-panel="gate"]', gate);
    var blockedPanel = $('[data-age-gate-panel="blocked"]', gate);
    var confirmBtn = $('[data-age-confirm]', gate);
    var denyBtn = $('[data-age-deny]', gate);

    function setPanel(state) {
      gate.setAttribute('data-state', state);
      if (gatePanel) gatePanel.hidden = state !== 'gate';
      if (blockedPanel) blockedPanel.hidden = state !== 'blocked';
    }

    function closeGate() {
      gate.hidden = true;
      document.body.style.overflow = '';
    }

    setPanel('gate');
    gate.hidden = false;
    document.body.style.overflow = 'hidden';

    if (confirmBtn) {
      confirmBtn.addEventListener('click', function () {
        localStorage.setItem(key, 'true');
        closeGate();
      });
      confirmBtn.focus();
    }

    if (denyBtn) {
      denyBtn.addEventListener('click', function () {
        setPanel('blocked');
      });
    }
  }

  /* -------------------------------------------------------------- header --- */
  function initHeader() {
    var toggle = $('[data-nav-toggle]');
    var panel = $('[data-nav-panel]');
    if (!toggle || !panel) return;

    var iconOpen = $('[data-nav-icon-open]', toggle);
    var iconClose = $('[data-nav-icon-close]', toggle);

    function setNav(open) {
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      if (iconOpen) iconOpen.hidden = open;
      if (iconClose) iconClose.hidden = !open;
    }

    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      setNav(panel.hidden);
    });

    // Clique fora fecha (espelha o handler de mousedown do Header.tsx)
    document.addEventListener('mousedown', function (e) {
      if (panel.hidden) return;
      if (toggle.contains(e.target) || panel.contains(e.target)) return;
      setNav(false);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) {
        setNav(false);
        toggle.focus();
      }
    });
  }

  /* --------------------------------------------------------- cart drawer --- */
  var lastFocused = null;

  function openCart() {
    var drawer = $('[data-cart-drawer]');
    var overlay = $('[data-cart-overlay]');
    if (!drawer) return;

    lastFocused = document.activeElement;
    drawer.hidden = false;
    if (overlay) overlay.hidden = false;

    // força reflow para a transição rodar
    void drawer.offsetWidth;
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    var close = $('[data-cart-close]', drawer);
    if (close && close.focus) close.focus();
  }

  function closeCart() {
    var drawer = $('[data-cart-drawer]');
    var overlay = $('[data-cart-overlay]');
    if (!drawer) return;

    drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';

    window.setTimeout(function () {
      drawer.hidden = true;
      if (overlay) overlay.hidden = true;
    }, 400);

    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  function applyCartDrawerHtml(html) {
    if (!html) return false;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var fresh = parsed.querySelector('.shopify-section') || parsed.body;
    var target = $('[data-cart-contents]');
    if (!fresh || !target) return false;
    target.innerHTML = fresh.innerHTML;
    return true;
  }

  function updateCartBadge(count) {
    var badge = $('[data-cart-count]');
    if (!badge || typeof count !== 'number') return;
    badge.textContent = count;
    badge.hidden = count === 0;
  }

  function fetchCartState() {
    return fetch(ROUTES.cart + '.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    }).then(function (r) { return r.json(); });
  }

  function fetchCartDrawerHtml() {
    return fetch('/?sections=cart-drawer', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function (data) { return data && data['cart-drawer']; });
  }

  function sectionHtmlFromResponse(res) {
    if (!res || !res.sections) return '';
    return res.sections['cart-drawer'] || '';
  }

  function refreshCart(open) {
    return fetchCartDrawerHtml()
      .then(function (html) {
        applyCartDrawerHtml(html);
        return fetchCartState();
      })
      .catch(function () { return fetchCartState(); })
      .then(function (cart) {
        if (!cart) return cart;
        updateCartBadge(cart.item_count);
        if (open) openCart();
        return cart;
      })
      .catch(function () { /* silencioso: o carrinho segue válido no servidor */ });
  }

  function changeLine(line, quantity) {
    var body = $('[data-cart-contents]');
    if (body) body.classList.add('is-loading');

    return fetch(ROUTES.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        line: line,
        quantity: quantity,
        sections: ['cart-drawer'],
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status && res.status !== 200) throw new Error(res.description || res.message);
        var html = sectionHtmlFromResponse(res);
        if (html) applyCartDrawerHtml(html);
        if (typeof res.item_count === 'number') {
          updateCartBadge(res.item_count);
          if (!html) return refreshCart(false);
          return res;
        }
        return refreshCart(false);
      })
      .catch(function () { return refreshCart(false); })
      .finally(function () {
        var b = $('[data-cart-contents]');
        if (b) b.classList.remove('is-loading');
      });
  }

  function initCart() {
    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-cart-open]');
      if (openBtn) { e.preventDefault(); openCart(); return; }

      var closeBtn = e.target.closest('[data-cart-close]');
      if (closeBtn) {
        // "Explorar o catálogo" é um link: deixa navegar.
        if (closeBtn.tagName !== 'A') e.preventDefault();
        closeCart();
        return;
      }

      var overlay = e.target.closest('[data-cart-overlay]');
      if (overlay) { closeCart(); return; }

      var qtyBtn = e.target.closest('[data-qty-change]');
      if (qtyBtn) {
        e.preventDefault();
        changeLine(Number(qtyBtn.dataset.line), Number(qtyBtn.dataset.qty));
      }
    });

    document.addEventListener('keydown', function (e) {
      var drawer = $('[data-cart-drawer]');
      if (e.key === 'Escape' && drawer && !drawer.hidden) closeCart();
    });

    document.addEventListener('velu:cart:refresh', function () { refreshCart(false); });
  }

  /* ----------------------------------------------------------- add to cart --- */
  function initProductForms() {
    $$('[data-product-form]').forEach(function (form) {
      if (form.dataset.cartBound === 'true') return;
      form.dataset.cartBound = 'true';

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = $('[data-add-to-cart]', form);
        if (btn) btn.disabled = true;

        var formData = new FormData(form);
        formData.append('sections', 'cart-drawer');
        formData.append('sections_url', window.location.pathname);

        fetch(ROUTES.cart_add, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
          body: formData
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) throw new Error(res.description || res.message);
            var html = sectionHtmlFromResponse(res);
            if (html) applyCartDrawerHtml(html);
            return fetchCartState().then(function (cart) {
              updateCartBadge(cart.item_count);
              openCart();
              if (!html) return fetchCartDrawerHtml().then(applyCartDrawerHtml);
            });
          })
          .catch(function (err) {
            var msg = $('[data-cart-error]', form);
            if (msg) {
              msg.textContent = err.message || (window.VELU.strings && window.VELU.strings.cartError);
              msg.hidden = false;
            }
          })
          .finally(function () { if (btn) btn.disabled = false; });
      });
    });
  }

  /* ------------------------------------------------------------- wishlist --- */
  function wishlistKey() { return CFG.wishlistKey || 'velu-wishlist'; }

  function readWishlist() {
    try {
      var raw = localStorage.getItem(wishlistKey());
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      // Mesmo shape do Zustand persist: {state:{handles:[…]},version:0}
      return (parsed.state && parsed.state.handles) || [];
    } catch (e) { return []; }
  }

  function writeWishlist(handles) {
    localStorage.setItem(wishlistKey(), JSON.stringify({ state: { handles: handles }, version: 0 }));
  }

  function initWishlist() {
    if (!CFG.wishlistEnabled) return;

    var handles = readWishlist();
    $$('[data-wishlist-toggle]').forEach(function (btn) {
      var handle = btn.dataset.handle;
      btn.setAttribute('aria-pressed', String(handles.indexOf(handle) !== -1));
    });

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-wishlist-toggle]');
      if (!btn) return;
      e.preventDefault();

      var handle = btn.dataset.handle;
      var list = readWishlist();
      var idx = list.indexOf(handle);

      if (idx === -1) list.push(handle);
      else list.splice(idx, 1);

      writeWishlist(list);

      $$('[data-wishlist-toggle][data-handle="' + handle + '"]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(idx === -1));
      });
      document.dispatchEvent(new CustomEvent('velu:wishlist:change'));
    });
  }

  /* -------------------------------------------------------------- reveals --- */
  function initReveals() {
    var nodes = $$('.reveal');
    if (!nodes.length) return;

    if (!('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('is-visible'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target); // viewport: {once:true}
      });
    }, { rootMargin: '0px 0px -10% 0px' });

    nodes.forEach(function (n) { io.observe(n); });
  }

  /* --------------------------------------------------- busca legada (?q=) --- */
  // /shop?q=x redirecionava para /collections/all, mas o Shopify não carrega a
  // querystring nos redirects. Reencaminha para a busca nativa.
  function initLegacySearch() {
    var params = new URLSearchParams(window.location.search);
    var q = params.get('q');
    if (!q) return;
    var path = window.location.pathname;
    if (path === '/collections/all' || path === '/collections') {
      window.location.replace(ROUTES.search + '?q=' + encodeURIComponent(q));
    }
  }

  /* ------------------------------------------------------------------ init --- */
  function init() {
    initAgeGate();
    initHeader();
    initCart();
    initProductForms();
    initWishlist();
    initReveals();
    initLegacySearch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-inicializa o que o Theme Editor recarrega
  document.addEventListener('shopify:section:load', function () {
    initProductForms();
    initWishlist();
    initReveals();
  });

  window.VELU = window.VELU || {};
  window.VELU.openCart = openCart;
  window.VELU.closeCart = closeCart;
  window.VELU.refreshCart = refreshCart;
})();
